import React from 'react'
import PropTypes from 'prop-types'
import ContinueInApp from './ContinueInApp'
import "./InstallAppBanner.scss"
import AppDownload from "./AppDownload";

export default function InstallAppBanner({caseId, isMobileDevice, availability, illustrationDark, illustrationLight}) {
    return <div className="mb-3">
            <div className="row justify-content-start">
                {isMobileDevice ? <ContinueInApp caseId={caseId} illustrationDark={illustrationDark} illustrationLight={illustrationLight}/> :
                    <AppDownload caseId={caseId} availability={availability} illustrationDark={illustrationDark} illustrationLight={illustrationLight}/>}
            </div>
        </div>
}

InstallAppBanner.propTypes = {
    caseId: PropTypes.string.isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    availability: PropTypes.string,
    illustrationDark: PropTypes.string,
    illustrationLight: PropTypes.string
}